import { useState } from "react";
import useLenis from "../hooks/useLenis";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Manifesto } from "../components/Manifesto";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Experiences } from "../components/Experiences";
import { Tiers } from "../components/Tiers";
import { ApplyForms } from "../components/ApplyForms";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  useLenis();
  const [selectedTier, setSelectedTier] = useState("");

  return (
    <div className="bg-ivory text-navy antialiased">
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Marquee />
        <Services />
        <Experiences />
        <Tiers onSelect={setSelectedTier} />
        <ApplyForms selectedTier={selectedTier} />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
